import React from "react";
import { createTheme, styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import styles from "./GiftCardHistoryTable.module.css";

let table_header_list = ["Username", "Date", "Amount", "Status"];

const GiftCardHistoryTable = (props) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: "#FFFFFF",
      fontFamily: "GilroySemiBold",
      fontSize: 14,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      color: "#000000",
      fontFamily: "GilroySemiBold",
      fontSize: 13,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: "#F5F5F5",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  let data = props.itemList;

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 5,
        "&.MuiTableContainer-root": { backgroundColor: "#FFFFFF" },
      }}
      elevation={0}
    >
      {data.length ? (
        <Table aria-label="customized table">
          <TableHead sx={{ backgroundColor: "#000000" }}>
            <TableRow>
              {table_header_list.map((x, i) => {
                return (
                  <StyledTableCell key={i} sx={{ borderBottom: "none" }}>
                    <Box>{x}</Box>
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>
                  <Box className={styles.nameText}>{item.name}</Box>
                  <Box className={styles.emailText}>{item.email}</Box>
                </StyledTableCell>
                <StyledTableCell>{item.date}</StyledTableCell>
                <StyledTableCell>${item.amount}</StyledTableCell>
                <StyledTableCell>
                  <Box
                    className={styles.statusView}
                    style={{
                      color: "#FFFFFF",
                      backgroundColor:
                        item.status == "top_up" ? "#1D86FF" : "#148E20",
                    }}
                  >
                    {item.status == "top_up" ? "Topup" : "Redeem"}
                  </Box>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      ) : null}
    </TableContainer>
  );
};

export default GiftCardHistoryTable;
